import React from 'react'

import './Line.scss'

export default function Line(props) {
	return <div className="line" />
}
